import { Webhook, FileCode, Building2, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const capacidades = [{
  icon: FileCode,
  title: "API de Notalia",
  desc: "Integra el alta de clientes y el screening en tus propios sistemas. Disponible en planes Pro y Enterprise para automatizar el KYC a escala."
}, {
  icon: Webhook,
  title: "Reportes XML SAT/UIF",
  desc: "Exporta los avisos en formato XML compatible con los sistemas de la autoridad, sin capturas manuales. Desde el plan Standard."
}, {
  icon: Building2,
  title: "Integración a medida",
  desc: "Para corporativos con sistemas internos, el plan Enterprise permite integraciones dedicadas y white-label completo."
}];
export default function IntegracionesApi() {
  return <section data-section-id="REEMPLAZAR" id="integraciones" className="bg-card text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Conecta Notalia con <span className="text-primary font-mono">tus sistemas</span>
          </h2>
          <p className="mt-4 max-w-[800px] text-lg text-slate-400 font-default">
            Desde reportes en formato oficial hasta una API completa para integrar el cumplimiento en tu operación.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {capacidades.map((cap, i) => {
          const Icon = cap.icon;
          return <div key={cap.title} data-index={i} className="p-6 md:p-8 rounded-lg bg-background border border-border hover:border-primary/40 transition-colors">
                <div className="size-12 rounded-md bg-primary/10 flex items-center justify-center mb-5">
                  <Icon className="size-6 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="font-default text-lg font-bold text-white mb-3">{cap.title}</h3>
                <p className="font-default text-sm text-slate-400 leading-relaxed">{cap.desc}</p>
              </div>;
        })}
        </div>

        <div className="mt-12 text-center">
          <Link to="/precios">
            <Button variant="ghost" className="font-mono uppercase tracking-widest text-primary hover:text-primary hover:bg-primary/10">
              Ver qué incluye cada plan
              <ArrowRight className="ml-2 size-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}